// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---gatsby-pages-index-js": () => import("../gatsby/pages/index.js" /* webpackChunkName: "component---gatsby-pages-index-js" */)
}

